export enum ToastModifier {
  SUCCCESS = "success",
  ERROR = "error",
  INFO = "info",
  WARNINIG = "warning",
}

export const IS_DEVELOPMENT = process.env.REACT_APP_SCOPE === "DEVELOPMENT";
export const IS_STAGING = process.env.REACT_APP_SCOPE === "STAGING";
export const IS_PRODUCTION = process.env.REACT_APP_SCOPE === "PRODUCTION";
